<template>
  <Card class="flex-fill mt-4">

    <div class="flex justify-between items-center mb-2 ">
      <h5 class="">
        {{scheduledPostsTitle}}
      </h5>

      <select class="bg-transparent px-2 focus:outline-none focus:bg-gray-200 " v-model="days" @change="getSchedulePosts">
        <option value="0">Today</option>
        <option value="7">Next 7 days</option>
        <option value="14">Next 14 days</option>
      </select>

    </div>
    <ul class="list-group post-list">
      <li class="list-group-item">
        <i class="fab fa-facebook-square" style="color: #4267b2; font-size: 2em;"></i>&nbsp;Facebook Posts
        <span class="float-right" ignore>{{ scheduledPosts.Facebook }}</span>
      </li>
      <li class="list-group-item">
        <i class="fab fa-twitter-square" style="color: #1ea0f1; font-size: 2em;"></i>&nbsp;Twitter Posts
        <span class="float-right" ignore>{{ scheduledPosts.Twitter }}</span>
      </li>
      <li class="list-group-item">
        <i class="fab fa-linkedin" style="color: #0078b5; font-size: 2em;"></i>&nbsp;LinkedIn Posts
        <span class="float-right" ignore>{{ scheduledPosts.LinkedIn }}</span>
      </li>
    </ul>
    <template #footer>
      <a class="text-danger" :href="`${cpixdomain}/aspen/manualPosting.htm`" target="_blank">+ Create Post</a>
      <a class="text-success float-right" :href="`${cpixdomain}/aspen/socialMediaDashboard.htm?objectType=${getEntity()}`">View All</a>
    </template>
  </Card>
</template>
<script>

  import Card from './Card';
  import {cpixdomain} from "../config";
  import {mapGetters} from 'vuex';

  export default {
    name: 'ScheduledPostsCard',

    components: {
      Card
    },

    data: function () {
      return {
        scheduledPosts: {
          Facebook: 0,
          Twitter: 0,
          LinkedIn: 0
        },
        days: 0
      }
    },

    computed: {
      ...mapGetters(['me']),
      cpixdomain() {
        return cpixdomain;
      },
      scheduledPostsTitle() {
        if (this.me.isImpersonated && this.me.impersonated.loggedInAs !== 'realtor') {
          return this.$helpers.capitalizeFirstLetter(this.me.impersonated.loggedInAs) + ' Scheduled Posts'
        }

        return 'Scheduled Posts'

      }
    },
    methods: {
      getEntity() {
        if (this.me.isImpersonated) {
          return this.$helpers.capitalizeFirstLetter(this.me.impersonated.loggedInAs)
        } else {
          return this.$helpers.capitalizeFirstLetter(this.me.tokenUser.loggedInAs)
        }
      },

      getSchedulePosts() {
        this.$http.get("/social/scheduled?daysAhead=" + this.days)
          .then(res => {
            this.scheduledPosts = res.data;
          });
      },

      dropdownSelected(days) {
        this.days = days;
        this.getSchedulePosts();
      }
    },

    mounted: function () {
      this.getSchedulePosts()
    }
  }
</script>

<style lang="scss">
  .post-list li {
    font-size: 1.25em;
  }

  .post-list span {
    font-size: 1.25em;
    color: #90c341;
  }

  .dropdown a {
    color: #999999;
  }

  .dropdown h5 {
    margin-bottom: 12px;
  }
</style>
